import { formatPrice } from "@/utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/sharp-solid-svg-icons";
import React from "react";

interface ExpenseDetailProps {
  label: string;
  value: number;
  info?: string;
}

const ExpenseDetail: React.FC<ExpenseDetailProps> = ({
  label,
  value,
  info,
}) => {
  return (
    <div className="flex justify-between homepage-text-sm ">
      <div className="flex items-center gap-1">
        <span>{label}</span>
        {info && (
          <FontAwesomeIcon
            className="size-3.5 text-gray-400"
            icon={faCircleInfo}
          />
        )}
      </div>
      <span className="homepage-text-sm ">
        {value > 0 ? formatPrice(value) : "-"}
      </span>
    </div>
  );
};

export default ExpenseDetail;
